import { User } from '../../../auth/model/user';
import { AuthActions, AuthApiActions, SigninPageActions } from '../actions';
import * as SettingsActions from '../../core/actions/settings.actions';
import jwt_decode from 'jwt-decode';
import { environment } from '../../../../environments/environment';

export interface State {
  user: User | null;
  isLoggedIn: boolean;
}

export function getInitialState(): State {
  const raw = localStorage.getItem(`${environment.storagePrefix}.currentUser`);
  const user = raw ? JSON.parse(raw) : null;
  return {
    user,
    isLoggedIn: !!user,
  };
}

export function reducer(
  state = getInitialState(),
  action: AuthActions.AuthActionsUnion | AuthApiActions.AuthApiActionsUnion | SigninPageActions.SigninPageActionsUnion | SettingsActions.SettingsActionsUnion
): State {
  switch (action.type) {
    case AuthApiActions.loginSuccess.type: {
      const decodedToken = jwt_decode(action.user.accessToken);
      const clientId = Number(JSON.parse(decodedToken['clientId']));
      const clientName =  decodedToken['clientName'];

      return {
        ...state,
        user: {...action.user, clientId, clientName},
        isLoggedIn: true
      };
    }
    case AuthApiActions.logoutSuccess.type:
    case AuthApiActions.logoutFailure.type: {
      return {
        ...state,
        user: null,
        isLoggedIn: null
      };
    }
    case AuthActions.updateToken.type: {
      const username = state.user ? state.user.username : null;
      const language = state.user ? state.user.language : 'pl';
      const decodedToken = jwt_decode(action.token);
      
      return {
        ...state,
        user: {
          language: language,
          accessToken: action.token,
          username: username,
          clientName: decodedToken['clientName'],
          clientId: Number(JSON.parse(decodedToken['clientId'])),
          modules: JSON.parse(decodedToken['teagleVisability']),
          privileges: JSON.parse(decodedToken['privileges']),
          settings: JSON.parse(decodedToken['settings'])
        }
      };
    }
    case SigninPageActions.autoLogout.type: {
      return {
        ...state,
        user: null,
        isLoggedIn: false
      };
    }
    case AuthActions.setUser.type: {
      const username = state.user ? state.user.username : null;
      const decodedToken = jwt_decode(action.token);
      return {
        ...state,
        user:  {
          language: action.language || 'pl',
          accessToken: action.token,
          username: username,
          clientName: decodedToken['clientName'],
          clientId: Number(JSON.parse(decodedToken['clientId'])),
          modules: JSON.parse(decodedToken['teagleVisability']),
          privileges: JSON.parse(decodedToken['privileges']),
          settings: JSON.parse(decodedToken['settings'])
        },
        isLoggedIn: true
      };
    }
    case SettingsActions.changeUserAccountSuccess.type: {
      if (action.data && action.data.newLogin) {
        const user = {...state.user};
        user.username = action.data.newLogin;
        return {
          ...state,
          user: user
        };
      }
      return {
        ...state
      };
    }
    default: {
      return state;
    }
  }
}

export const getUser = (state: State) => state.user;
export const isLoggedIn = (state: State) => state.isLoggedIn;
export const hasPrivilege = (state: State, privilege: string) => state.user?.privileges?.some(item => item === privilege);
